// extracted by mini-css-extract-plugin
export default {"nav":"UserNav_nav__QMGTj","name":"UserNav_name__hr-jw","item":"UserNav_item__CS-1N","settings":"UserNav_settings__5wXdD"};